import React, { useCallback } from 'react';
import { Button, Row } from '@ydistri/ds';
import { addToast } from '@ydistri/utils';
import { TbPlus } from 'react-icons/tb';
import { useCreateAsoScopeMutation } from '../apiAso';
import { useAsoScenarioStatus } from '../hooks/useAsoScenarioStatus';
import { getRequestErrorMessage } from '../../../lib/utils/getRequestErrorMessage';
import { useAppDispatch } from '../../../store';

export interface AsoScopesHeaderActionProps {
  asoScenarioId?: number;
}

const AsoScopesHeaderAction: React.FC<AsoScopesHeaderActionProps> = ({ asoScenarioId }) => {
  const [createScope, { isLoading }] = useCreateAsoScopeMutation();
  const { isLocked } = useAsoScenarioStatus();
  const dispatch = useAppDispatch();

  const handleCreateScope = useCallback(async () => {
    if (!asoScenarioId || isLocked) return;

    try {
      await createScope({ asoScenarioId }).unwrap();
    } catch (error) {
      dispatch(
        addToast({
          isError: true,
          message: getRequestErrorMessage(error, 'The ASO scope could not be created.'),
        }),
      );
    }
  }, [asoScenarioId, createScope, dispatch, isLocked]);

  return (
    <Row $alignItems="center" $gap="0.5rem">
      <Button
        disabled={!asoScenarioId || isLoading || isLocked}
        loading={isLoading}
        onClick={() => void handleCreateScope()}
      >
        <TbPlus />
        Add ASO scope
      </Button>
    </Row>
  );
};

export default AsoScopesHeaderAction;
